import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
    ITransferOrderDetailsResponseData,
  ITransferOrderGRNResponse,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
// import { useRouter } from "@/app/hooks/useRouter";
// import { useNavigate } from "react-router";
import { setTransferOrderGRNId } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useGRNAgainstTransferOrderAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const { enable, disable } = useLoaderActions("isPOCreateInProgress");
  //   const { getRouteKey } = useRouter();
  //     const navigate = useNavigate();

  const execute = useCallback(
    async (filterProps: ITransferOrderDetailsResponseData) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(INVENTORY_MODULE?.GRN_AGAINST_TRANSFER_ORDER?.baseURL ?? "", filterProps, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ITransferOrderGRNResponse>) => {
            disable();
            if (res.data.status === true) {
              console.log(res.data.data?.grn_id)
                localStorage.setItem("TransferOrderGRNId",res.data.data?.grn_id )
              dispatch(setTransferOrderGRNId(res.data.data?.grn_id));
              //   navigate(getRouteKey("TRANSFER_ORDERS", "url"));
              toast.success(res.data.message);
              //   return res.data.data;
            } else {
              toast.error(res.data.message);
              //   return null;
            }
          })
          .catch((e: AxiosError) => {
            toast.error(e.message);
            sendCurl(e.config["curlCommand"]);
            disable();
            captureError(e)
            return null;
          });
      } catch (e: any) {
        disable();
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};